module.exports = __webpack_public_path__ + "img/icon-restaurant-mini-bill.79aaa678.png";